import rekitLogo from '../images/rekit-logo.svg';

export const config = {
  siteName: '管理后台',
  copyright: '富瑞特装 ©2019',
  logoPath: rekitLogo,
  apiPrefix: '/api/v1',
  fixedHeader: true, // sticky primary layout   
  downloadUrl: 'http://findapi.furuine.com:8899',
  // downloadUrl: 'http://114.55.253.103:8084', // 配置文件下载地址
  // attachUrl: 'http://furuiapi.zhelut.com', //
  // http://furuiapi.zhelut.com
  attachUrl: 'http://findapi.furuine.com:8899',
  Url: '',
  /* Layout configuration, specify which layout to use for route. */
  layouts: [{
    name: 'primary',
    include: [/.*/],
    exclude: [/(\/(en|zh))*\/login/],
  }, ],
}


// WEBPACK FOOTER //
// ./src/utils/config.js